/* global Sys, Core */
Sys.ns("Core");

Core.messageApi = {
    NETENT_EXTEND_ELE_ID: "netEntExtendPlugin",
    GAME_ADAPTER_API_TOPIC: "game-adapter-api",
    TARGET_ORIGIN: "*",

    isInIframe: function() {
        var isInIframe;

        try {
            isInIframe =
                // Added window.parent check due to possibility of operator rewriting it: FOUN-804
                window.self !== window.top && window.self !== window.parent;
        }
        catch (e) {
            isInIframe = true;
        }

        return isInIframe;
    },

    getIFrameWindow: function() {
        var isInIframe = this.isInIframe(),
            pluginsIframe = document.getElementById(this.NETENT_EXTEND_ELE_ID);

        if (isInIframe) {
            return window.parent;
        }

        if (pluginsIframe) {
            return pluginsIframe.contentWindow;
        }

        return null;
    },

    sendMessage: function(payload) {
        var iFrameWindow = this.getIFrameWindow(),
            postData = {
                topic: this.GAME_ADAPTER_API_TOPIC,
                payload: payload
            };

        if (iFrameWindow) {
            iFrameWindow.postMessage(postData, this.TARGET_ORIGIN);
        }
    },

    createMessageEventSender: function() {
        return function(type, data) {
            var payload = {
                event: type,
                data: data
            };

            this.sendMessage(payload);
        }.bind(this);
    },

    createResultSender: function() {
        return function(payload) {
            this.sendMessage(payload);
        }.bind(this);
    },

    createMessageApi: function() {
        return {
            sendMessageEvent: this.createMessageEventSender(),
            sendResultEvent: this.createResultSender()
        };
    }
};
